import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import {formatDate} from '@angular/common';
import { LeadsService } from '../_service/leads.service';
import { SharedService } from '../_service/shared.service';
import { MiscService } from '../_service/misc.service';
import { ActivatedRoute, Router  } from '@angular/router';
import Handsontable from 'handsontable';
import { HotTableRegisterer } from '@handsontable/angular';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {UpdateInsuranceModalComponent} from '../insurance/update-insurance-modal/update-insurance-modal.component';
import {UpdatePreauthModalComponent} from '../insurance/update-preauth-modal/update-preauth-modal.component';
import{ GlobalConstants } from '../common/global-constants';
import {OpdModalComponent} from '../opd/opd-modal/opd-modal.component';
import {IpdModalComponent} from '../ipd/ipd-modal/ipd-modal.component';
import {FollowDnpModalComponent} from '../lead_section/follow-dnp-modal/follow-dnp-modal.component';
import { FollowDnpDetailModalComponent } from '../lead_section/follow-dnp-detail-modal/follow-dnp-detail-modal.component';
import { CrossBdComponent } from '../lead_section/cross-bd/cross-bd.component';
import { NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AddLabLeadModalComponent } from '../lab_section/add-lab-lead-modal/add-lab-lead-modal.component';
import { PlanShareModalComponent } from '../plans/plan-share-modal/plan-share-modal.component';
import { ShareHealthProductPaymentlinkComponent } from '../lead_section/share-health-product-paymentlink/share-health-product-paymentlink.component';
import { UserService } from '../_service/user.service';

import * as XLSX from 'xlsx';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { ProductModelComponent } from '../product_section/product-model/product-model.component';
import { HairRemovalModelComponent } from '../hair_removal_section/hair-removal-model/hair-removal-model.component';
declare var $: any;
@Component({
  selector: 'app-excelview',
  templateUrl: './excelview.component.html',
  styleUrls: ['./excelview.component.css']
})
export class ExcelviewComponent implements OnInit {
    @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
    @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;

    @ViewChild('followupdateRangeStart', {static: false}) followupdateRangeStart: ElementRef;
    @ViewChild('followupdateRangeEnd', {static: false}) followupdateRangeEnd: ElementRef;

    @ViewChild('ipddateRangeStart', {static: false}) ipddateRangeStart: ElementRef;
    @ViewChild('ipddateRangeEnd', {static: false}) ipddateRangeEnd: ElementRef;

    @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    leads:any=[];private hotRegisterer = new HotTableRegisterer();alltreatments=[];treatments=[];leadStatus=[];circles=[];userId:string;
    id = 'hotInstance'; settings = {colHeaders: true };bds=[];paymentOpt=[];leadallStatus=[];allbds=[];treatment='';ActionOpt=[];hideColumn:any;gender=[];treatment_modal='';
    perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;roleStatus=false;circle='';sheetCircle=[];
    pageSizeOptions = [10,25,50,100];pageIndex:number=0;loaded:boolean=false;myrole:string;submitted = false;adminRole:boolean=true; qaRole:boolean=false;
    search:string;lead_source:any;lead_status:string;bd:string;start_date:string='';end_date:string='';width=200;followupadte:string;leadClickId;
    showInsurance:string;leadStatus_copy=[];bds_copy=[];circles_copy=[];treatments_copy=[];showopdDonebutIpdNotDone:string;bridgeno;copyData:boolean= false;LeadId;
    datanew=[];category_filter:string;patient_type:string;payment_mode:string;leadDnpFollowDetail:any;Checkdnpmodal:boolean=true; dnpFollowupmodalcheck:boolean=false;lead_category_filter='';treatCategory=[];tertiary_city_filter:string;isCMAccess:string;c2crecording:string;
    tertiarycityFilter:boolean=false;treatmentCategoryAccess:string;
    displayInactiveUsersLead:boolean;lead_sources=[];bridge_number_lists=[];start_date_follow_up:string='';end_date_follow_up:string='';updatedLodData=[];history_loading:boolean=true;history_loaded:boolean=false;cross_bd_lead_id = '';
    click_to_call_loading:boolean=false;nimbus_click_to_call_loading:boolean=false;response_call_id='';progression_msg='';end_to_call_btn_disable=false;nimbus_end_to_call_btn_disable=false;router_uri = '';
    start_date_ipd:string='';end_date_ipd:string='';userTreatmentCat = [];
    otpForm: FormGroup;otpsubmitted = false;showmobilebtn:boolean = false;wrongOtpdiv:boolean=false;corporate_lead_source = '';insurance_status = ''; tap_count = '';
    leadmobilenumber:any;showmobilenumberdiv:boolean= false; sendotpbtn = false;otploader= false; paymentModeRole:boolean=true;allpre_sale_users = [];pre_sale_users_filter:string;patient_mobile_num='';sendMessageloading:boolean= false;gender_filter:string;
    allTapValues=[
        {"id":1,"name":"Tap1"},{"id":2,"name":"Tap2"},{"id":3,"name":"Tap3"},{"id":4,"name":"Tap4"},{"id":5,"name":"Tap5"},
        {"id":6,"name":"Tap6"},{"id":7,"name":"Tap7"},{"id":8,"name":"Tap8"},{"id":9,"name":"Tap9"},{"id":10,"name":"Tap10"}
    ]

    constructor(private formBuilder: FormBuilder,private leadapi:LeadsService,private sharedapi:SharedService,private dialog:MatDialog,public miscapi:MiscService,private router: Router, private userapi:UserService)
    {
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.isCMAccess = localStorage.getItem('CMAccess');
        if(this.myrole=='2')
        {
            this.roleStatus = true;
        }else if(this.myrole=='1')
        {
            this.adminRole = false;
        }
        if(this.myrole=='15' || this.myrole=='1'){
            this.qaRole = true;
        }
        
        if(this.myrole=='2' || this.myrole=='3'){
            this.userTreatmentCat = localStorage.getItem('user_catergory_access').split(',');
        }

        
        /*---===Payment Mode only enable for Admin and Category Manager=========--------*/

        if(this.myrole=='1' || (this.myrole=='3' && this.isCMAccess == '1')){
            this.paymentModeRole = false;
        } 
        
       

        
        this.treatmentCategoryAccess = localStorage.getItem('treatment_catergory_access');

        this.paymentOpt = ['Cash','Cashless','Reimbursement','EMI','Cheque','Razorpay','Net Banking'];
        
        this.ActionOpt = ['Select','Upload Insurance Card','Send Preauth Request','Post OPD','Post IPD','Create Duplicate Lead','Book Scan','Book Lab Test','Product Info','Hair Removal'];
        // for making Action menu options //
        if((this.myrole=='2' || this.myrole=='3') ){
            if(this.userTreatmentCat.includes('10')){
                this.ActionOpt = ['Select','Book Scan','Book Lab Test'];
                this.paymentOpt = ['Cash','EMI','Cheque','Razorpay','Net Banking'];
                //console.log('dental');
            }
            else{
                console.log('non dental');
                //this.ActionOpt = ['Select','Upload Insurance Card','Send Preauth Request','Post OPD','Post IPD','Book Lab Test','Product Info','Hair Removal'];
                this.ActionOpt = ['Select','Upload Insurance Card','Send Preauth Request','Post OPD','Post IPD','Book Lab Test','Product Info','Hair Removal'];    
            }
        }
        
        this.gender=['Male','Female'];
        this.userId = localStorage.getItem('loginuserId');
        /* console.log(this.userId); */

        this.getbds();this.getcircle();this.getLeadSources();this.getBridgeNumberLists();
        this.getleadStatus();this.getTreatment();this.getTreatmentCategory();
        this.loadCommonData();
        this.get_pre_salesbds();

        this.router_uri = this.router.url;

        if(this.myrole=='1' || (this.myrole=='15' && this.userId=='313')){
            this.pageSizeOptions = [10,25,50,100,500];
        }

        this.otpForm = this.formBuilder.group({ 
            'otp' : [null, Validators.required],
            'leadID' : [null, Validators.required],
            //'leadMobile': [null, Validators.required]

        });

    }

    get f() { return this.otpForm.controls; }

    
    selectAll(select: NgModel) {
        let values: any[] = []; // array which will contain all values
        // loop through all groups and add their items' values to the array
        for(let group of this.allbds){
          values.push(group.id);
        }
        let data = values.map(x=>`${x}`).toString().split(',');
        select.update.emit(data);
        this.loadleads(0,this.perpage);

      }
    
      deselectAll(select: NgModel) {
        select.update.emit([]);
        this.loadleads(0,this.perpage);
      }

    ngOnInit(): void {
        
    }
    ngAfterViewInit() {
        this.loadleads(0,25);
    }

    resetFilters(){
        this.clearDate();
        this.clearDateFollowUp();
        this.clearDateIPD();
        this.search = ''; this.lead_source = '';  this.lead_status = ''; this.bd = ''; this.circle = ''; this.treatment = ''; this.bridgeno = ''; this.lead_category_filter = ''; this.patient_type = ''; this.category_filter = ''; this.payment_mode = ''; this.tertiary_city_filter = ''; this.followupadte = '';  this.displayInactiveUsersLead = false; this.c2crecording=''; this.showInsurance = ''; this.showopdDonebutIpdNotDone = ''; this.corporate_lead_source = '';this.insurance_status = '';this.pre_sale_users_filter = ''; this.gender_filter = '';this.tap_count = '';
        this.loadleads(0,25);
    }

    openDnpFollowupDetailDialog(leadId)
    {
        const dialogRef = this.dialog.open(FollowDnpDetailModalComponent, {
            width: '50%',height: '70%',
            data:{leadId:leadId}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    openleadHistoryPopup(leadIId)
    {
        this.history_loading = true;this.history_loaded = false;
        this.leadapi.getFullLeadHistory(leadIId).subscribe((data:any) => {
            this.history_loading = false;
            this.history_loaded = true;
            if(data.status)
            {
                this.updatedLodData = data.data;
            }else{
                this.updatedLodData = [];
                /* this.sharedapi.presentToast(data.msg); */
            }
        }, error => {
                this.sharedapi.checkError(error);
        });
        $('#myHistoryModal').modal();
    }

    closeHistoryPopup()
    {
        $('#myHistoryModal').modal('hide');
    }

    afterOnCellMouseDownCallBack = (event, coords, TD) =>
    {
        if(event.target.nodeName.toLowerCase() == 'button'){
            let leadId = event.target.attributes.id.nodeValue;
            this.openDnpFollowupDetailDialog(leadId);
        }
        if(event.target.nodeName.toLowerCase() == 'a'){
            let leadIId = event.target.attributes.id.nodeValue;
            this.openleadHistoryPopup(leadIId);
        }
        /* commented on 19-12-22 */
        /* if(coords.col == GlobalConstants.sheetColumns.description){ //description column
          //remove description when click on desctiption cell
          const alldata= this.hotRegisterer.getInstance(this.id);
          alldata.setDataAtCell(coords.row,coords.col,'');
        } */
        if(event.target.className == 'click_to_call')
        {
            let leadId = event.target.attributes.id.nodeValue;
            this.click_to_call_function(leadId);
            
        }
        if(event.target.className == 'nimbus_click_to_call')
        {
            let leadId = event.target.attributes.id.nodeValue;
            this.nimbus_click_to_call_function(leadId);
            
        }
        if(event.target.className == 'share_plan')
        {
            let leadId = event.target.attributes.id.nodeValue;
            this.openPlanShareModal(leadId);
            
        }
        if(event.target.className == 'share_health_product')
        {
            //console.log(event.target)
            let leadId = event.target.attributes.id.nodeValue;
            let leadName = event.target.attributes.value.nodeValue;
            //console.log(leadName)
            this.openShareHealthProductModal(leadId,leadName);
            
        }
        if(event.target.className == 'mobileClass')
        {
            let leadData = event.target.attributes.id.nodeValue.split('_');

            this.leadapi.showmobilenumber(leadData[1]).subscribe((data:any) => {
                let leadDivId = event.target.attributes.id.nodeValue;
                if($("#"+leadDivId).html() === "**********" ){
                    if(this.myrole=='1' || (this.myrole=='3' && this.isCMAccess == '1'))
                    {
                        $("#"+leadDivId).html(data.data);
                    } else {
                        $("#"+leadDivId).html("**********");
                    }
                    
                }else{
                    $("#"+leadDivId).html("**********");
                }
            }, error => {
                this.sharedapi.checkError(error);
              });

            // for number masking with otp commented on 2-sep-22 by archit sir//
            // if((this.userTreatmentCat.includes('7') || this.userTreatmentCat.includes('6') || this.userTreatmentCat.includes('12')) && (this.userId!='233' && this.userId!='368' && this.userId!='325' && this.userId!='412')){
            //     $("#mobile_view_otp").modal("show");
            //     this.otpForm.patchValue({
            //         'leadID':leadData[1]
            //     }) 
            // }else{
            //     this.leadapi.showmobilenumber(leadData[1]).subscribe((data:any) => {
            //         let leadDivId = event.target.attributes.id.nodeValue;
            //         if($("#"+leadDivId).html() === "**********" ){
            //             $("#"+leadDivId).html(data.data);
            //             }else{
            //                 $("#"+leadDivId).html("**********");
            //         }
            //     }, error => {
            //         this.sharedapi.checkError(error);
            //       });
            // }

            // if(this.userTreatmentCat.includes('7')){
            //     $("#mobile_view_otp").modal("show");
            //     this.otpForm.patchValue({
            //         'leadID':leadData[1],
            //         'leadMobile' : leadData[2] 
            //     }) 
            // }else{
            //     let leadMobile = leadData[2];
            //     let leadDivId = event.target.attributes.id.nodeValue;
            //     if($("#"+leadDivId).html() === "**********" ){
            //         $("#"+leadDivId).html(leadMobile);
            //     }else{
            //         $("#"+leadDivId).html("**********");
            //     }
            // }
        }
    }

    openPlanShareModal(lead_id)
    {
        const dialogRef = this.dialog.open(PlanShareModalComponent, {
            width: '35%',height: '35%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            //this.loadleads(0,this.perpage);
        });
    }

    openShareHealthProductModal(lead_id,leadName)
    {
        const dialogRef = this.dialog.open(ShareHealthProductPaymentlinkComponent, {
            width: '45%',height: '45%',
            data:{lead_id:lead_id,leadName:leadName}
        });

        dialogRef.afterClosed().subscribe(result => {
            //this.loadleads(0,this.perpage);
        });
    }



    sendOtp(){
        this.sendotpbtn = true;
        this.otploader = true;
        let leadId = this.otpForm.get('leadID').value;
        //let leadMobile = this.otpForm.get('leadMobile').value;

        this.leadapi.sendMobileViewotp(this.userTreatmentCat,leadId)
        .subscribe((data:any) => {
            if(data.status)
            {
                this.showmobilebtn = true;
                this.sendotpbtn = false;
                this.otploader = false;
                
            }
        }, error => {
            this.sharedapi.checkError(error);
          });
    }

    showMobileNumber(){
        console.log(this.otpForm.controls);
        this.otpsubmitted = true;
        // // stop here if form is invalid
        if (this.otpForm.invalid) {
            this.loading = false;
            return;
        }
        let otp = this.otpForm.get('otp').value;
        let leadId = this.otpForm.get('leadID').value;
        //let leadMobile = this.otpForm.get('leadMobile').value;

        this.leadapi.verifyOtp(otp,leadId)
        .subscribe((data:any) => {
            if(data.status)
            {
                this.wrongOtpdiv = false;
                this.showmobilenumberdiv = true;
                this.leadmobilenumber = data.data;
                this.showmobilebtn = false;
                
            }else{
                this.wrongOtpdiv = true;
                this.showmobilenumberdiv = false;
            }
        }, error => {
            this.sharedapi.checkError(error);
          });
    }

    endMobileViewModal()
    {
        $('#mobile_view_otp').modal('hide');
        this.showmobilebtn = false;
        this.showmobilenumberdiv = false;
        this.otpForm.reset();
    }
    

    click_to_call_function(lead_id)
    {
        this.click_to_call_loading = true;
        let lead_id_arr = {'lead_id': lead_id};
        this.leadapi.clickTOCall(lead_id_arr).subscribe((data:any) => {
            this.click_to_call_loading = false;
            console.log(data);
            if(data.status){
                this.response_call_id = data.call_id;
                this.patient_mobile_num = data.patient_mobile;
                $("#click_to_call_progress").modal("show");
            } else {
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    endClicktoCall()
    {
        this.progression_msg = "";
        this.end_to_call_btn_disable = true;
        if(this.response_call_id)
        {
            let lead_id_arr = {'response_call_id': this.response_call_id};
            this.leadapi.endClicktoCall(lead_id_arr).subscribe((data:any) => {
                this.end_to_call_btn_disable = false;
                $('#click_to_call_progress').modal('hide');
                // if(data.status){
                //     if(data.data.data.length > 0) {
                //         if(data.data.data[0].duration > 0) {
                //             this.response_call_id = '';
                //             $('#click_to_call_progress').modal('hide');
                //             this.loadleads(0,this.perpage);
                //         } else {
                //             this.progression_msg = "Please cut the call from mobile first, then click on end call here.";
                //         }
                //     } else {
                //         this.progression_msg = "Phone is ringing, You cannot end the call yet. If you remove popup, can reload the page.";
                //     }
                // } else {
                //     this.sharedapi.presentToast(data.msg);
                // }
            }, error => {
                this.sharedapi.checkError(error);
            });
        } else {
            this.sharedapi.checkError("Please reload the page. Something went to wrong.");
        }
        
    }

    nimbus_click_to_call_function(lead_id)
    {
        this.nimbus_click_to_call_loading = true;
        let nimbus_lead_id_arr = {'lead_id': lead_id};
        $("#nimbus_click_to_call_progress").modal("show");
        this.leadapi.nimbusClickTOCall(nimbus_lead_id_arr).subscribe((data:any) => {
            this.nimbus_click_to_call_loading = false;
            if(data.status==false){
                $("#nimbus_click_to_call_progress").modal("hide");
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    endNimbusClicktoCall()
    {
        this.end_to_call_btn_disable = true;
        $('#nimbus_click_to_call_progress').modal('hide');
        this.end_to_call_btn_disable = false;
    }


    setSearchValue(type){
        if(type=='lead_status'){
            $("#lead_status_Search").val('');
            $("#lead_status_Search").focus();
            this.leadallStatus= this.leadStatus_copy;
        }else if(type=='bds'){
            $("#bd_search").val('');
            $("#bd_search").focus();
            this.allbds= this.bds_copy;
        }else if(type=='circle'){
            $("#circleSearch").val('');
            $("#circleSearch").focus();
            this.circles= this.circles_copy;
        }else if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.alltreatments= this.treatments_copy;
        }else if(type=='treatment_modal'){
            $("#treatmentModalSearch").val('');
            $("#treatmentModalSearch").focus();
            this.alltreatments= this.treatments_copy;
        }
    }

    searchOnSelect(searchtText: string, type){
        if (type == 'lead_status') {
            this.leadallStatus = this.sharedapi.searchData(searchtText, this.leadStatus_copy, "name");
        }else if(type == 'bds'){
            this.allbds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
        }else  if (type == 'circle') {
            this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
        }else  if (type == 'treatment') {
            this.alltreatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }else  if (type == 'treatment_modal') {
            this.alltreatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }
    }

    get_pre_salesbds(){
        this.userapi.getpresalesbds().subscribe((data:any) => {
            if(data.status)
            {
                this.allpre_sale_users = data.data;
                
            }else{
                this.allpre_sale_users = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    sendWhatsappMessage(){
        let qString = 'insurance='+this.showInsurance+'&search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&bd='+this.bd+'&lead_source='+this.lead_source+'&followupdate='+this.followupadte+'&date_range='+this.start_date+'-'+this.end_date+'&ipdopnd='+this.showopdDonebutIpdNotDone+'&bridgeno='+this.bridgeno+'&category_filter='+this.category_filter+'&patient_type='+this.patient_type+'&payment_mode='+this.payment_mode+'&lead_category_filter='+this.lead_category_filter+'&tertiary_city_filter='+this.tertiary_city_filter+'&display_inactive_user_list='+this.displayInactiveUsersLead+'&follow_up_date_range='+this.start_date_follow_up+'-'+this.end_date_follow_up+'&c2crecording='+this.c2crecording+'&ipd_date_range='+this.start_date_ipd+'-'+this.end_date_ipd+'&corporate_lead_source='+this.corporate_lead_source+'&insurance_status='+this.insurance_status+'&pre_sale_users='+this.pre_sale_users_filter+'&gender_filter='+this.gender_filter+'&tap_count='+this.tap_count;
        
        this.sendMessageloading = true;
        this.leadapi.getLeadsForWhatsAppMessage(qString).subscribe((data:any) => {
            if(data){
                this.sendMessageloading = false;
            }
        });
    }

    async loadleads(pageIndex,perpage)
    {
        this.tertiarycityFilter = false;
        if(this.circle.indexOf('8') !== -1){
            this.tertiarycityFilter = true;
        }
        if(this.displayInactiveUsersLead == true) {
          this.getbds(0);
        } else {
          this.getbds();
        }
        this.leads = [];
        this.paginator.pageIndex = pageIndex;
        this.paginatorBottom.pageIndex = pageIndex;
        this.pageIndex = pageIndex;
        
        let lead_type = "";
        if(this.router.url == "/partner-lead-sheetview"){
            lead_type = "partner";
        }


        let qString = 'insurance='+this.showInsurance+'&search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&bd='+this.bd+'&lead_source='+this.lead_source+'&followupdate='+this.followupadte+'&date_range='+this.start_date+'-'+this.end_date+'&ipdopnd='+this.showopdDonebutIpdNotDone+'&bridgeno='+this.bridgeno+'&category_filter='+this.category_filter+'&patient_type='+this.patient_type+'&payment_mode='+this.payment_mode+'&lead_category_filter='+this.lead_category_filter+'&tertiary_city_filter='+this.tertiary_city_filter+'&display_inactive_user_list='+this.displayInactiveUsersLead+'&follow_up_date_range='+this.start_date_follow_up+'-'+this.end_date_follow_up+'&lead_type='+lead_type+'&c2crecording='+this.c2crecording+'&ipd_date_range='+this.start_date_ipd+'-'+this.end_date_ipd+'&corporate_lead_source='+this.corporate_lead_source+'&insurance_status='+this.insurance_status+'&pre_sale_users='+this.pre_sale_users_filter+'&gender_filter='+this.gender_filter+'&tap_count='+this.tap_count;
        
        this.loading = true;this.loaded = false;
        this.leadapi.getLeadsSheet(pageIndex,perpage,qString).subscribe((data:any) => {
            this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.leads = data.data;
                if(this.myrole == '6' && this.userId!='58'){
                    this.hideColumn = {columns: [8,9,10,11,43],indicators: true};
                }
                if(this.myrole == '18' || this.myrole == '15'){
                    this.hideColumn = {columns: [8,9,10,11,43],indicators: true};
                }
                


            }else{
                this.leads = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    exportTrainingLeadData()
    {
        if(this.leads.length>0)
        {
            let data = [];
            let titles = [
                'Patient Id','Glamyo Patient Id', 'Lead Source', 'Lead Status', 'Lead Location', 'Circle', 'Lead Owner','Employee Id', 'Treatment', 'Description', 'Lead Date', 'Surgery Date','Follow-up Date', 'C2C Recording Status', 'C2C Recording Links', 'Kaleyra Recording Links'
            ];


            data.push(titles);
            for(let key in this.leads)
            {
                var surgery_date =''; var follow_update = ""; var lead_time = "";
                if(this.leads[key].ipd_surgery_date){
                    surgery_date = formatDate(this.leads[key].ipd_surgery_date*1000, 'dd MMM, yyyy', 'en-US');
                }
                let recording_status = 'No';
                if(this.leads[key].click_to_call_recording)
                {
                    recording_status = 'Yes';
                }
                
                let exdata = [
                    this.leads[key].patient_id,
                    this.leads[key].glamyo_patient_id,
                    this.leads[key].lead_source,
                    this.leads[key].lead_status_name,
                    this.leads[key].city_name,
                    this.leads[key].circle_name,
                    this.leads[key].bd_name,
                    this.leads[key].employee_id,
                    this.leads[key].treatment_name,
                    this.leads[key].description,
                    this.leads[key].lead_time,
                    //this.leads[key].lead_first_actionTime,
                    //this.leads[key].lead_first_action.replace(/<[^>]*>/g, ''),
                    surgery_date,
                    this.leads[key].followup_date,
                    recording_status,
                    this.leads[key].click_to_call_recording_only,
                    this.leads[key].export_kaleyra_call_link
                ];
                data.push(exdata);
            }


            let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'lead_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('Something went wrong, Try Again!');
        }
    }

    async saveDetails()
    {
        this.submitted = true;
       let data= this.hotRegisterer.getInstance(this.id).getSourceData();
       let alldata = {'data':data};
       if(data.length>0)
       {
            await this.leadapi.updateSheetData(alldata).subscribe((data:any) => {
                this.submitted = false;
                if(data.status)
                {
                    this.sharedapi.presentToast(data.msg);
                }else{
                    this.sharedapi.presentToast(data.msg);
                }
            }, error => {
                 this.sharedapi.checkError(error);
            });
        }
    }

    async loadCommonData()
    {
        await this.leadapi.getCommonData().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.treatment;
                /* console.log(this.treatments); */
                this.bds = data.bd;
                this.leadStatus = data.lead_status;
                this.sheetCircle = data.circle;
            }else{
                this.leadStatus = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadleads(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadleads(event.pageIndex,event.pageSize);
    }

    async getleadStatus()
    {
        await this.leadapi.getLeadStatus().subscribe((data:any) => {
            if(data.status)
            {
                this.leadallStatus = data.data;
                this.leadStatus_copy = this.leadallStatus;
            }else{
                this.leadallStatus = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getbds(status=1)
    {
        await this.leadapi.getbds(status).subscribe((data:any) => {
            if(data.status)
            {
                this.allbds = data.data;
                this.bds_copy = this.allbds;
            }else{
                this.allbds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.alltreatments = data.data;
                this.treatments_copy = this.alltreatments;
            }else{
                this.alltreatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    async getTreatmentCategory()
    {
        await this.miscapi.getTreat_Category().subscribe((data:any) => {
            if(data.status)
            {
                this.treatCategory = data.data;
            }else{
                this.treatCategory = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
                this.circles_copy = this.circles;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getBridgeNumberLists()
    {
        this.leadapi.getBridgeNumberLists().subscribe((data:any) => {
            if(data.status)
            {
                this.bridge_number_lists = data.data;
            }else{
                this.bridge_number_lists = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getLeadSources()
    {
        /* this.leadapi.getLeadSources().subscribe((data:any) => {
            if(data.status)
            {
                this.lead_sources = data.data;
            }else{
                this.lead_sources = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        }); */
        let uri = '';
        if(this.router.url == "/partner-lead-sheetview"){
            uri = "partner_lead";
        } else {
            uri = "none";
        }

        this.leadapi.getUpdatedLeadSources(uri).subscribe((data:any) => {
            if(data.status)
            {
                this.lead_sources = data.data;
            }else{
                this.lead_sources = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    dateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.start_date = date1.value;
            this.end_date = date2.value;
            //this.loadleads(0,this.perpage);
        }
    }

    dateRangeChangefollowUp(date1,date2)
    {
        if(date2.value)
        {
            this.start_date_follow_up = date1.value;
            this.end_date_follow_up = date2.value;
            //this.loadleads(0,this.perpage);
        }
    }

    dateRangeIPD(date1,date2)
    {
        if(date2.value)
        {
            this.start_date_ipd = date1.value;
            this.end_date_ipd = date2.value;
            //this.loadleads(0,this.perpage);
        }
    }

    clearDate()
    {
        this.dateRangeStart.nativeElement.value = "";
        this.dateRangeEnd.nativeElement.value = "";
        this.start_date = '';
        this.end_date = '';
        //this.loadleads(0,this.perpage);
    }

    clearDateFollowUp()
    {
        this.followupdateRangeStart.nativeElement.value = "";
        this.followupdateRangeEnd.nativeElement.value = "";
        this.start_date_follow_up = '';
        this.end_date_follow_up = '';
        //this.loadleads(0,this.perpage);
    }

    clearDateIPD()
    {
        this.ipddateRangeStart.nativeElement.value = "";
        this.ipddateRangeEnd.nativeElement.value = "";
        this.start_date_ipd = '';
        this.end_date_ipd = '';
        //this.loadleads(0,this.perpage);
    }

    onBeforeChange = (hotInstance, changes) =>
    {
        let data= this.hotRegisterer.getInstance(this.id).getSourceData();
        let saveData = {id:data[hotInstance[0][0]].id,field_name:hotInstance[0][1],old_value:hotInstance[0][2],new_value:hotInstance[0][3],index:hotInstance[0][0]};
        this.saveOnChange(saveData);
    }


    getPaymentTreatmentStatus(saveData){
        console.log(saveData);
        this.leadapi.getpaymenttreatmentStatus(saveData.id).subscribe((data:any) => {
            if(data.status)
            {
                if(data.result.status==true){ // If payment mode and treatment updated
                    if(saveData.new_value=='Upload Insurance Card'){
                        if(data.result.data.modePayment=="Cashless" || data.result.data.modePayment=="Reimbursement"){
                            this.openInsuranceDialog(saveData.id);
                        }else{
                            $("#paymentModeErrorModal").modal();
                            $("#PaymentModeErrorMessage").text('Your payment mode is not cashless or Reimbursement. Please select different payment mode.');
                        }

                    } else if (saveData.new_value=='Send Preauth Request') {
                        if(data.result.data.modePayment=="Cashless" || data.result.data.modePayment=="Reimbursement"){
                            if(data.result.data.upload_preauth_status > 0) {
                                this.openPreAuthDialog(saveData.id);
                            } else  {
                                $("#paymentModeErrorModal").modal();
                                $("#PaymentModeErrorMessage").text('Your insurance details has not been approved or preauth files has been already uploaded for this lead.');
                            }
                        }else{
                            $("#paymentModeErrorModal").modal();
                            $("#PaymentModeErrorMessage").text('Your payment mode is not cashless or Reimbursement. Please select different payment mode.');
                        }
                    }
                    else if(saveData.new_value=='Post OPD'){
                        this.openOpdDialog(saveData.id);
                    }
                    else if(saveData.new_value=='Post IPD'){
                        this.openIpdDialog(saveData.id);
                    }
                    else if(saveData.new_value=='Create Duplicate Lead'){
                        if(this.myrole=='1' || (this.myrole=='3' && this.isCMAccess=='1')){
                            this.showDuplicateModal(saveData.id);
                        }else{
                            this.sharedapi.presentToast('You cannot do this action please contact your category manager');
                        }
                        
                    }
                    else if(saveData.new_value=='Book Scan'){
                        const url = this.router.serializeUrl(
                          this.router.createUrlTree(['/book-scan/' + saveData.id])
                        );
                        window.open(url, '_blank');
                    }
                    else if(saveData.new_value=='Book Lab Test'){
                        this.openBookLabTestDialog(saveData.id);
                    } 
                    else if(saveData.new_value=='Product Info'){
                        this.openProductDialog(saveData.id);
                    }
                    else if(saveData.new_value=='Hair Removal'){
                        this.openHairRemovalDialog(saveData.id);
                    }
                    //for check dnp-followup modal //
                    else if(saveData.field_name=='lead_status_name'){
                        console.log(saveData);
                       if(saveData.new_value=='DNP-1' || saveData.new_value=='DNP-2' || saveData.new_value=='DNP-3' || saveData.new_value=='DNP-4' || saveData.new_value=='DNP-5'  || saveData.new_value=='Follow Up-1' || saveData.new_value=='Follow Up-2' || saveData.new_value=='Follow Up-3' || saveData.new_value=='Dnp Exhausted'){
                           // check for dnp follow up data exits or not //
                           this.checkDnpFollowUpDataExists(saveData);
                            
                        }else{
                            console.log("up-1")
                            this.updateSingleData(saveData);
                        }
                    }
                }else{ // If payment mode and treatment not updated
                    console.log(saveData);
                    if(saveData.field_name=='lead_status_name' && (saveData.new_value=='DNP-1' || saveData.new_value=='DNP-2' || saveData.new_value=='DNP-3' || saveData.new_value=='DNP-4' || saveData.new_value=='DNP-5' || saveData.new_value=='Follow Up-1' || saveData.new_value=='Follow Up-2' || saveData.new_value=='Follow Up-3' || saveData.new_value=='Dnp Exhausted')){
                       // check for dnp follow up data exits or not //
                       console.log(saveData);
                       this.checkDnpFollowUpDataExists(saveData);
                    }
                    //else if(saveData.field_name=='lead_status_name' && (saveData.new_value=='Cross BD' || saveData.new_value=='Dnp Exhausted' || saveData.new_value=='Covid' || saveData.new_value=='New Lead' || saveData.new_value=='Junk Lead' || saveData.new_value=='Out of city' || saveData.new_value=='Supply Gap')){
                    else if(saveData.field_name=='lead_status_name' && (saveData.new_value=='Cross BD' || saveData.new_value=='Covid' || saveData.new_value=='New Lead' || saveData.new_value=='Junk Lead' || saveData.new_value=='Out of city' || saveData.new_value=='Supply Gap')){    
                        console.log(saveData);
                        console.log("up-2")
                        this.updateSingleData(saveData);
                    }
                    else{
                        console.log(saveData);
                        this.openDnpFollowModal(saveData.id,saveData.new_value,saveData, data.result);
                        this.Checkdnpmodal=true;
                    }
                }
            }
        })
    }

    checkDnpFollowUpDataExists(saveData){
        let pagetype=3;
        if(saveData.new_value.includes('DNP') || saveData.new_value.includes('Dnp')){
            pagetype=1;
        } else if(saveData.new_value.includes('Follow')) {
           pagetype=2;
        }
        this.leadapi.checkDnpFollowUpDataExist(saveData.id,saveData.new_value,pagetype).subscribe((data:any) =>
        {
            console.log(saveData);
            console.log(data);
            console.log(data.data);
            console.log(data.status);
            if(data.status){
                if(data.data > 0){
                    console.log("case if");
                    console.log(this.Checkdnpmodal);
                    if(this.Checkdnpmodal==true && (data.result.data.display_followup==1 || (pagetype == 2 && (data.result.data.paymentMode==0 || data.result.data.treatment==0)))){
                        console.log("case if -1");
                        this.openDnpFollowModal(saveData.id,saveData.new_value,saveData,data.result);
                        this.Checkdnpmodal=false;
                    } else {
                        console.log("else part2");
                      this.updateSingleData(saveData);
                      // Insert record into followup dnp table when direct follow up date change..
                      var dnpFollowupFormData: any = new FormData();
                      dnpFollowupFormData.append('lead_id', saveData.id);
                      dnpFollowupFormData.append('pagetype', pagetype);
                      dnpFollowupFormData.append('type', saveData.new_value);
                      dnpFollowupFormData.append('dnp_followup_date', data.result.data.followUpDate);
                      dnpFollowupFormData.append('fieldName', saveData.field_name);
                      dnpFollowupFormData.append('comments', data.result.data.description);
                      dnpFollowupFormData.append('old_status', saveData.old_value);

                      this.leadapi.addDnpFollowUpData(dnpFollowupFormData).subscribe((data:any) => {}, error =>
                      {
                        this.sharedapi.checkError(error);
                      });

                    }
                }else{
                    console.log("else part1");
                  if(data.msg_type =='Toast'){
                    this.sharedapi.presentToast(data.message);
                  } 
                  else {
                    console.log("else part2");
                    console.log(saveData);
                    // modal for when prevoius data not entered//
                     $("#previousdnpfollowModal").modal();
                     $("#ActionTextMessage").text(data.message);
                    //this.sharedapi.presentToast(data.message);
                    
                    // in case of re-ording of column need to update setDataAtCell value
                    // if(data.message || data.msg){
                        
                    //     const alldata= this.hotRegisterer.getInstance(this.id);
                    //     alldata.setDataAtCell(saveData.index,GlobalConstants.sheetColumns.status,saveData.old_value);
                    //     this.Checkdnpmodal=false;
                    // }
                    
                  }
                }
            }else{
                this.sharedapi.presentToast('You cannot mark this lead as '+saveData.new_value+', because this lead status is in Hot Lead,OPD Schedule, IPD Schedule, Fund Issue, Follow-ups State.');
                
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async saveOnChange(saveData)
    {
        ///console.log(saveData);
        if(saveData.field_name=='action')
        {
            //console.log("if case");
            this.getPaymentTreatmentStatus(saveData);
        }else{
            //console.log("else case");
            if(saveData.field_name=='lead_status_name'){
                if(saveData.new_value=="IPD Done" || saveData.new_value=="IPD Scheduled" || saveData.new_value=="OPD Done" || saveData.new_value=="OPD Scheduled"){
                    this.sharedapi.presentToast("You cannot do this action, because this action will perform auctomatically while post opd or ipd");
                    return false;
                }
                this.Checkdnpmodal=true;
                this.getPaymentTreatmentStatus(saveData);
            }else{
                console.log("up-3");
                console.log(this.Checkdnpmodal);
                if(this.Checkdnpmodal==true){
                    console.log(this.Checkdnpmodal);
                   this.updateSingleData(saveData);
                }
                
            }
        }
    }
    updateSingleData(saveData){
        console.log(saveData);
        if(saveData.field_name == 'lead_status_name' && saveData.new_value == 'Cross BD')
        {
            this.cross_bd_lead_id=saveData.id;
            this.open_cross_bd_modal(saveData);
        }
        // else if(saveData.field_name == 'lead_status_name' && saveData.new_value == 'Dnp Exhausted' && (saveData.new_value != 'Hot Lead' || saveData.new_value != 'OPD Scheduled'  || saveData.new_value != 'IPD Scheduled'  || saveData.new_value != 'Fund Issues'  || saveData.new_value != 'Follow Up-1'  || saveData.new_value != 'Follow Up-2'  || saveData.new_value != 'Follow Up-3')){
        //     console.log("in caterggg");
        //     this.sharedapi.presentToast('You cannot mark this lead as '+saveData.new_value+', because this lead status is in Hot Lead,OPD Schedule, IPD Schedule, Fund Issue, Follow-ups State.');
        // }

        else
        {
            this.cross_bd_lead_id='';
            this.submitted = true;
            this.leadapi.updateSingleData(saveData).subscribe((data:any) =>
            {
                this.submitted = false;
                if((saveData.field_name == "description" && saveData.new_value!='') || (saveData.field_name != "description")){
                    this.sharedapi.presentToast(data.msg);
                    this.Checkdnpmodal=true;
                }
               
            }, error => {
                this.sharedapi.checkError(error);
            });
        }
        
    }

    open_cross_bd_modal(saveData)
    {
        const dialogRef = this.dialog.open(CrossBdComponent, {
            width: '50%',height: '50%',
            data:{cross_bd_lead_id:this.cross_bd_lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
            this.loadleads(0,this.perpage);
        });
    }


    openDnpFollowModal(leadId,type,saveData, currentData)
    {
      let pagetype=3;
      if(saveData.new_value.includes('DNP') || saveData.new_value.includes('Dnp')){
          pagetype=1;
      } else if(saveData.new_value.includes('Follow')) {
         pagetype=2;
      }
        let fieldName = saveData.field_name;
        let old_status = saveData.old_value;
        const dialogRef = this.dialog.open(FollowDnpModalComponent, {
            width: '40%',height: '350px',
            data:{leadId,pagetype,type,currentData,fieldName,old_status}
        });

        dialogRef.afterClosed().subscribe(result => {
            if(result){
                console.log(result);
                if(result.event=='Cancel' && saveData.field_name =='lead_status_name'){
                    // in case of re-ording of column need to update setDataAtCell value
                    const alldata= this.hotRegisterer.getInstance(this.id);
                    alldata.setDataAtCell(saveData.index,GlobalConstants.sheetColumns.status,saveData.old_value);
                    this.Checkdnpmodal=false;
                }
            }
        });
    }

    showDuplicateModal(leadid){
        this.LeadId= leadid;
        $('#duplicateModal').modal();
    }

    hideduplicateModal()
    {
        $('#duplicateModal').modal('hide');
    }
    hideStatusModal(type)
    {
        if(type==1){
            $('#paymentTreatmentModal').modal('hide');
        }else if(type==2){
            $('#previousdnpfollowModal').modal('hide');
        }else{
            $('#paymentModeErrorModal').modal('hide');
        }
    }
    hide_cross_bd_modal()
    {
        $('#cross_bd_modal').modal('hide');
    }


    copyLead(){
        this.copyData=true;
        this.leadapi.copyLeadData(this.LeadId).subscribe((data:any) => {
            if(data.status)
            {
                this.copyData=false;
                $('#duplicateModal').modal('hide');
                this.loadleads(0,this.perpage);
            }
        }, error => {
            this.copyData=false;
            this.sharedapi.checkError(error);
        });
    }

    openInsuranceDialog(lead_id)
    {
        const dialogRef = this.dialog.open(UpdateInsuranceModalComponent, {
            width: '100%',height: '90%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    openOpdDialog(lead_id)
    {
        const dialogRef = this.dialog.open(OpdModalComponent, {
            width: '100%',height: '90%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    openIpdDialog(lead_id)
    {
        const dialogRef = this.dialog.open(IpdModalComponent, {
            width: '100%',height: '90%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    openBookLabTestDialog(lead_id)
    {
        const dialogRef = this.dialog.open(AddLabLeadModalComponent, {
            width: '100%',height: '60%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            this.loadleads(0,this.perpage);
        });
    }

    openPreAuthDialog (lead_id) 
    {
        const dialogRef = this.dialog.open(UpdatePreauthModalComponent, {
            width: '100%',height: '95%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    openProductDialog (lead_id) 
    {
        const dialogRef = this.dialog.open(ProductModelComponent, {
            width: '100%',height: '95%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    clearCell(event){
      const alldata= this.hotRegisterer.getInstance(this.id);
    }

    openHairRemovalDialog (lead_id) 
    {
        const dialogRef = this.dialog.open(HairRemovalModelComponent, {
            width: '100%',height: '95%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    selectAllTap(select: NgModel) {
        let values: any[] = []; // array which will contain all values
        // loop through all groups and add their items' values to the array
        for(let group of this.allTapValues){
          values.push(group.id);
        }
        let data = values.map(x=>`${x}`).toString().split(',');
        select.update.emit(data);
        this.loadleads(0,this.perpage);

      }
    
      deselectAllTap(select: NgModel) {
        select.update.emit([]);
        this.loadleads(0,this.perpage);
      }

}
